import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NavigationComponent } from "./layout/navigation/navigation.component";
import { ModalComponent } from './components/modal/modal.component';
import { UserFormComponent } from './components/users/user-form/user-form.component';
import { FilialsListComponent } from './components/filials/filials-list/filials-list.component';
import { InventarProductsComponent } from './components/inventar-products/inventar-products.component';
import { NewFilialComponent } from './components/filials/new-filial/new-filial.component';
import { BreadcrumbModule } from "xng-breadcrumb";
import { FilialComponent } from './components/filial/filial.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { AppSpinnerDirective } from "./components/spinner/app-spinner.directive";
import { WebhooksComponent } from "./components/webhooks/webhooks.component";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule, NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { FilialItemComponent } from "./components/filials/filial-item/filial-item.component";
import { FilialProfileComponent } from "./components/filial/filial-profile/filial-profile.component";
import { ProductItemComponent } from './components/inventar-products/product-item/product-item.component';
import { InventarItemComponent } from './components/inventars/inventar-item/inventar-item.component';
import { WebhookItemComponent } from './components/webhooks/webhook-item/webhook-item.component';
import { UserItemComponent } from "./components/users/user-item/user-item.component";
import { ChangePasswordFormComponent } from './components/users/change-password-form/change-password-form.component';
import { ButtonComponent } from './components/button/button.component';
import { FilialAdminFormComponent } from './components/filials/filial-admin-form/filial-admin-form.component';
import { WorkersListComponent } from './components/workers/workers-list/workers-list.component';
import { WorkersItemComponent } from './components/workers/workers-item/workers-item.component';
import { WorkersComponent } from "./components/workers/workers.components";
import { UsersListComponent } from './components/users/users-list/users-list.component';
import { UserComponent } from './components/users/user/user.component';
import { ActivityLogComponent } from './components/modals/activity-log/activity-log.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
export { AppSpinnerDirective };

@NgModule({
  declarations: [
    NavigationComponent,
    ModalComponent,
    UserFormComponent,
    UserItemComponent,
    FilialItemComponent,
    FilialProfileComponent,
    FilialsListComponent,
    InventarProductsComponent,
    NewFilialComponent,
    FilialComponent,
    SpinnerComponent,
    WebhooksComponent,
    AppSpinnerDirective,
    ProductItemComponent,
    InventarItemComponent,
    WebhookItemComponent,
    ChangePasswordFormComponent,
    ButtonComponent,
    FilialAdminFormComponent,
    WorkersListComponent,
    WorkersItemComponent,
    WorkersComponent,
    UsersListComponent,
    UserComponent,
    ActivityLogComponent,
    SearchInputComponent,
    CustomSelectComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    BreadcrumbModule,
    TranslateModule,
    NgbModule,
    NgbPaginationModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    
  ],
  exports: [
    NavigationComponent,
    ModalComponent,
    UserFormComponent,
    UserItemComponent,
    AppSpinnerDirective,
    TranslateModule,
    ChangePasswordFormComponent,
    ButtonComponent,
    FilialAdminFormComponent,
    WorkersListComponent,
    WorkersItemComponent,
    WorkersComponent,
    UsersListComponent,
    UserComponent,
    InventarItemComponent,
    ActivityLogComponent,
    SearchInputComponent
  ]
})
export class SharedModule { }
